import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${Spacing.S40} ${Spacing.S24};
  position: relative;

  &::before {
    content: '';
    height: calc(100% - 108px);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 0;
    background: ${Color.Grey200};
    clip-path: ellipse(100% 100% at 50% 0%);
  }

  > * {
    position: relative;
    z-index: 1;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R24};
  background-color: ${Color.Grey100};
`
